module.exports = __webpack_public_path__ + "img/10.5878c8d3.png";